export const palette = {
  alternate: {
    main: '#F9F6FF',
    light: '#F9F8F8',
    dark: '#E5EAF4',
  },
  cardShadow: 'rgba(23, 70, 161, .11)',
  type: 'light',
  primary: {
    main: '#596058',
    light: '#F1F5DF',
    contrastText: '#FFFFFF'
  },
  secondary: {
    main: '#43C2BD',
    contrastText: '#0A5285',
    light: '#D9EDF7'
  },
  text: {
    primary: '#0E2E3B',
    secondary: '#23262F',
    alternate: '#23B0E7',
    disabled: '#CCC',
    highlight: '#FFF',
    success: '#1CA179',
    border: '#E5EAF4',
    arrow:'#292D32'
  },
  divider: 'rgba(0, 0, 0, 0.12)',
  background: {
    main: '#F8F3EC',
    paper: '#FFF',
    default: '#FFF',
    subscription: '#576057',
    header: 'rgba(229, 251, 254, 0.8)',
    footer: '#CDD7C3',
    level2: '#f7f8fb',
    level1: '#FFF',
    steps: '#43C2BD',
    tableHead: '#BACE60',
    tableSubhead: '#F7F7F7',
    tableBorder: '#7D808880',
    tableAlternate: '#F8F8F8',
    alternate: '#d4f1f9',
    success: '#DBEFDC',
    error: '#FFEAEA',
    primary: 'rgba(207, 205, 163, 0.2)',
    secondary: 'rgb(240,243,243)',
    light: 'rgba(238, 236, 233, 0.6)',
    arrow: '#BACE60',
    secondaryLight: '#F9F9F5'
  },
  verticalBar: {
    used: '#BACE60',
    unused: '#F1F5DF',
    unlimited: '#C0C0C0',
  }
};